import { render, staticRenderFns } from "./lista-buscador-seleccion.vue?vue&type=template&id=2d572ca6&scoped=true&"
import script from "./lista-buscador-seleccion.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion.vue?vue&type=style&index=0&id=2d572ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d572ca6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VMenu,VRow,VSpacer})
